import { type StyleProp, View, type ViewStyle } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Checkbox from '@/components/UI/Checkbox';
import {
  areAllVisibleSelected,
  getUniqueIds,
  type SelectionStore,
  useSelectionIsSelected,
  useSelectionSelectedIds,
  useSelectionSetSelectedIds,
  useSelectionToggle,
} from '@/hooks/useSelection';

type TableSelectionCheckboxProps = {
  selectionStore: SelectionStore<string>;
  style?: StyleProp<ViewStyle>;
  testID: string;
  value: string;
};

type TableSelectionHeaderCheckboxProps = {
  disabled?: boolean;
  selectionStore: SelectionStore<string>;
  style?: StyleProp<ViewStyle>;
  testID: string;
  visibleIds: readonly string[];
};

export function TableSelectionCheckbox({
  selectionStore,
  style,
  testID,
  value,
}: TableSelectionCheckboxProps) {
  const selected = useSelectionIsSelected({ store: selectionStore, value });
  const toggle = useSelectionToggle(selectionStore);

  return (
    <View style={[styles.container, style]}>
      <Checkbox
        size="sm"
        showCheckmark={false}
        value={selected}
        variant="info"
        style={styles.checkbox}
        testID={testID}
        onValueChange={(nextSelected) => {
          toggle(value, nextSelected);
        }}
      />
    </View>
  );
}

export function TableSelectionHeaderCheckbox({
  disabled,
  selectionStore,
  style,
  testID,
  visibleIds,
}: TableSelectionHeaderCheckboxProps) {
  const selectedIds = useSelectionSelectedIds(selectionStore);
  const setSelectedIds = useSelectionSetSelectedIds(selectionStore);
  const allVisibleSelected = areAllVisibleSelected({
    selectedIds,
    visibleIds,
  });

  return (
    <View style={[styles.container, style]}>
      <Checkbox
        disabled={disabled}
        size="sm"
        showCheckmark={false}
        value={allVisibleSelected}
        variant="info"
        style={styles.checkbox}
        testID={testID}
        onValueChange={(selected) => {
          setSelectedIds(selected ? getUniqueIds(visibleIds) : []);
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  checkbox: {
    alignItems: 'center',
    alignSelf: 'stretch',
    flex: 1,
    gap: 0,
    justifyContent: 'center',
    width: '100%',
  },
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
